import MoneyInput from "./components/CurrencyInput";

export default MoneyInput;
